import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './_helpers/guards/auth.guard';
import { LoginSsoComponent } from './auth/login-sso/pages/login-sso/login-sso.component';
import { NgModule } from '@angular/core';
import { NoAuthGuard } from './_helpers/guards/no-auth.guard';
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then( m => m.AuthModule ),
    canLoad: [ NoAuthGuard ]
  },
  {
    path: "sso",
    component: LoginSsoComponent,
    canLoad: [NoAuthGuard]
  },
  {
    path: "control",
    loadChildren: () => import("./administracion/administracion.module").then( m => m.AdministracionModule ),
    canLoad: [ AuthGuard ]
  },{
    path: 'admin',
    loadChildren: () => import('./superadmin/superadmin.module').then( m => m.SuperadminModule ),
    canLoad: [ AuthGuard ] 
  },{
    path: 'soporte',
    loadChildren: ()=> import ('./soporte/soporte.module').then(m => m.SoporteModule), 
    canLoad: [ AuthGuard ]
  },{
    path: '404',
    component: NotFoundComponent
  },{
    path: "**", redirectTo: "auth"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
